<template>
   <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
      <template #button-content>         
         <span>Vedi azioni</span>
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-more-items"></use></svg><span class="sr-only">Vedi azioni</span>
      </template>                     
      <!--b-dropdown-item @click.prevent="downloadItem">
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-download"></use></svg>
         Scarica
      </b-dropdown-item-->
      <b-dropdown-item @click="print">
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-print"></use></svg>
         Stampa
      </b-dropdown-item>
      <b-dropdown-item :href="mailto" target="_blank">
         <svg class="icon icon-primary mr-1"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="@/assets/img/sprite.svg#it-mail"></use></svg> 
         Invia
      </b-dropdown-item>

                                    
   </b-dropdown>   
</template>
<script>
//import axios from 'axios';
import { saveAs } from 'file-saver';

export default {
   name: "actionArea",
   components: {
   },
   props: {
      type: {
        type: Boolean,
        default: true,
        description: "Should print 'Condividi' in front of icon"
     },
   },
   data() {
      return {
      }
   },
   methods: {
      print () {
         this.$root.print();
      },
      downloadItem () { 
         //var blob = new Blob(["Hello, world!"], {type: "text/plain;charset=utf-8"});
         saveAs(window.location.href, this.$root.title+".html");
      }    
   },
   computed:{
      mailto: function(){
         return "mailto://?subject="+encodeURI(this.$root.title)+"&body="+encodeURI(window.location.href);
      }
   }
};
</script>            
<style>
.btn.dropdown-toggle.btn-link{
   padding: 1px 6px !important;
}
.read-more + .icon{
   margin-left: 8px;
   fill: #003594;
   width: 16px;
   height: 16px;
   flex-shrink: 0;
}
</style>